import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { AreaChart } from '@/components/charts/AreaChart';
import { useErrorRate } from '@/hooks/useAdminMonitoring';

export function ErrorRateChart() {
  const { data } = useErrorRate();
  const chartData = (data?.data || []).map((d: { hour: string; errors: number }) => ({
    date: d.hour,
    errors: d.errors,
  }));

  return (
    <Card>
      <CardHeader title="Taux d'erreur (24h)" />
      <CardContent>
        <AreaChart
          data={chartData}
          areas={[{ key: 'errors', color: '#ef4444', label: 'Erreurs' }]}
          height={200}
        />
      </CardContent>
    </Card>
  );
}
